import type {
  AllowedStatesQueryParams,
  AllowedStatesRequestData,
  AllowedStatesResponse
} from '@library/types/allowedStates';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';

const { admin } = apiPaths;

export const allowedStatesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllowedStates: build.query<
      AllowedStatesResponse,
      AllowedStatesQueryParams
    >({
      query: ({ sortBy, sortDir, page, perPage }) => ({
        url: `${admin}models/allowed_states`,
        method: 'GET',
        params: {
          page,
          per_page: perPage,
          sort_by: sortBy,
          sort_dir: sortDir
        },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      })
    }),
    createAllowedState: build.mutation<
      AllowedStatesResponse,
      AllowedStatesRequestData
    >({
      query: (newAllowedStateData) => ({
        url: `${admin}models/allowed_states`,
        method: 'POST',
        body: { stat_type: newAllowedStateData },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformErrorResponse: (response) => response.data
    }),
    updateAllowedState: build.mutation<
      AllowedStatesResponse,
      { id: string; data: AllowedStatesRequestData }
    >({
      query: ({ id, data }) => ({
        url: `${admin}/models/allowed_states/${id}`,
        method: 'PATCH',
        body: { stat_type: data },
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformErrorResponse: (response) => response.data
    }),
    deleteAllowedState: build.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `${admin}/models/allowed_states/${id}`,
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json; charset=UTF-8'
        }
      }),
      transformErrorResponse: (response) => response.data
    })
  })
});

export const {
  useGetAllowedStatesQuery,
  useCreateAllowedStateMutation,
  useUpdateAllowedStateMutation,
  useDeleteAllowedStateMutation
} = allowedStatesApi;
